import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/theme';
import { FaDiscord, FaInstagram, FaLinkedin, FaMastodon, FaReddit } from 'react-icons/fa';
import BlueskyIcon from './icons/Bluesky';

const FooterSection = styled.footer`
  background-color: ${theme.colors.gray[900]};
  color: ${theme.colors.white};
  padding: ${theme.spacing[12]} ${theme.spacing[4]};
  scroll-margin-top: ${theme.navHeight.desktop};
  
  @media (max-width: ${theme.breakpoints.md}) {
    scroll-margin-top: ${theme.navHeight.mobile};
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${theme.spacing[8]};
  
  @media (max-width: ${theme.breakpoints.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: ${theme.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[4]};
`;

const ColumnTitle = styled.h3`
  font-size: ${theme.typography.fontSize.lg};
  font-weight: ${theme.typography.fontWeight.semibold};
  color: ${theme.colors.white};
`;

const LinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[2]};
`;

const Link = styled.a`
  color: ${theme.colors.gray[400]};
  text-decoration: none;
  font-size: ${theme.typography.fontSize.base};
  transition: color 0.3s ease;
  
  &:hover {
    color: ${theme.colors.white};
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: ${theme.spacing[4]};
`;

const SocialIcon = styled.a`
  color: ${theme.colors.gray[400]};
  font-size: ${theme.typography.fontSize.xl};
  transition: color 0.3s ease;
  
  &:hover {
    color: ${theme.colors.white};
  }
`;

const NewsletterForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[4]};
`;

const NewsletterInput = styled.input`
  padding: ${theme.spacing[2]} ${theme.spacing[4]};
  border-radius: ${theme.borderRadius.lg};
  border: 1px solid ${theme.colors.gray[700]};
  background-color: ${theme.colors.gray[800]};
  color: ${theme.colors.white};
  font-size: ${theme.typography.fontSize.base};
  
  &::placeholder {
    color: ${theme.colors.gray[500]};
  }
  
  &:focus {
    outline: none;
    border-color: ${theme.colors.primary};
  }
`;

const NewsletterButton = styled.button`
  padding: ${theme.spacing[2]} ${theme.spacing[4]};
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  border: none;
  border-radius: ${theme.borderRadius.lg};
  font-size: ${theme.typography.fontSize.base};
  font-weight: ${theme.typography.fontWeight.semibold};
  cursor: pointer;
  transition: background-color 0.3s ease;
  
  &:hover {
    background-color: ${theme.colors.gray[800]};
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: ${theme.spacing[12]};
  padding-top: ${theme.spacing[8]};
  border-top: 1px solid ${theme.colors.gray[800]};
  color: ${theme.colors.gray[500]};
  font-size: ${theme.typography.fontSize.sm};
`;

const Footer: React.FC = () => {
  return (
    <FooterSection id="join">
      <Container>
        {/* <FooterColumn>
          <ColumnTitle>About Us</ColumnTitle>
          <LinkList>
            <Link href="/about">Our Story</Link>
            <Link href="/mission">Mission & Vision</Link>
            <Link href="/team">Team</Link>
            <Link href="/careers">Careers</Link>
          </LinkList>
        </FooterColumn>
        <FooterColumn>
          <ColumnTitle>Features</ColumnTitle>
          <LinkList>
            <Link href="/grower-dashboard">Grower Dashboard</Link>
            <Link href="/consumer-insights">Consumer Insights</Link>
            <Link href="/community-reviews">Community Reviews</Link>
            <Link href="/sustainability">Sustainability</Link>
          </LinkList>
        </FooterColumn> */}
        {/* <FooterColumn>
          <ColumnTitle>Resources</ColumnTitle>
          <LinkList>
            <Link href="/blog">Blog</Link>
            <Link href="/guides">Growing Guides</Link>
            <Link href="/faq">FAQ</Link>
            <Link href="/support">Support</Link>
          </LinkList>
        </FooterColumn> */}
        <FooterColumn>
          <ColumnTitle>Connect</ColumnTitle>
          <SocialLinks>
            <SocialIcon href="https://discord.gg/AjRQSUGc6u" target="_blank" rel="noopener noreferrer">
              <FaDiscord />
            </SocialIcon>
            <SocialIcon href="https://mastodon.social/@greengrowersclub" target="_blank" rel="noopener noreferrer">
              <FaMastodon />
            </SocialIcon>
            <SocialIcon href="https://www.instagram.com/greengrowersclub" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </SocialIcon>
            <SocialIcon href="https://www.linkedin.com/company/green-growers-club" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </SocialIcon>
            <SocialIcon href="https://www.reddit.com/r/greengrowersclub" target="_blank" rel="noopener noreferrer">
              <FaReddit />
            </SocialIcon>
            <SocialIcon href="https://bsky.app/profile/greengrowers.club" target="_blank" rel="noopener noreferrer">
              <BlueskyIcon />
            </SocialIcon>
          </SocialLinks>
          {/* <NewsletterForm>
            <NewsletterInput
              type="email"
              placeholder="Enter your email"
              required
            />
            <NewsletterButton type="submit">
              Subscribe
            </NewsletterButton>
          </NewsletterForm> */}
        </FooterColumn>
        {/* terms and conditions */}
        <FooterColumn>
          <ColumnTitle>Terms & Conditions</ColumnTitle>
          <LinkList>
            <Link href="/terms">Terms of Service</Link>
            <Link href="/terms#privacy-policy">Privacy Policy</Link>
          </LinkList>
        </FooterColumn>
      </Container>
      <Copyright>
        © {new Date().getFullYear()} Green Growers Club. All rights reserved.
      </Copyright>
    </FooterSection>
  );
};

export default Footer;
